import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

interface PremiumAnalyticsHeaderProps {
  title: string;
  subscriptionTier: 'premium' | 'pro' | 'enterprise';
  onUpgrade?: () => void;
}

export const PremiumAnalyticsHeader: React.FC<PremiumAnalyticsHeaderProps> = ({
  title,
  subscriptionTier,
  onUpgrade,
}) => {
  const getTierColor = () => {
    switch (subscriptionTier) {
      case 'premium':
        return '#6750A4';
      case 'pro':
        return '#FF6B35';
      case 'enterprise':
        return '#2E7D32';
      default:
        return '#6750A4';
    }
  };

  const getTierLabel = () => {
    switch (subscriptionTier) {
      case 'premium':
        return 'Premium';
      case 'pro':
        return 'Pro';
      case 'enterprise':
        return 'Enterprise';
      default:
        return 'Premium';
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{title}</Text>
        <View style={[styles.tierBadge, { backgroundColor: getTierColor() }]}>
          <Ionicons name='diamond' size={12} color='#FFFFFF' />
          <Text style={styles.tierText}>{getTierLabel()}</Text>
        </View>
      </View>

      <Text style={styles.subtitle}>
        AI-powered insights and personalized coaching
      </Text>

      {subscriptionTier === 'premium' && onUpgrade && (
        <TouchableOpacity style={styles.upgradeButton} onPress={onUpgrade}>
          <Ionicons name='arrow-up-circle-outline' size={16} color='#6750A4' />
          <Text style={styles.upgradeText}>Upgrade to Pro</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1F2937',
    marginRight: 12,
  },
  tierBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    gap: 4,
  },
  tierText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  subtitle: {
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 8,
  },
  upgradeButton: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#EDE7F6',
    borderRadius: 16,
    gap: 4,
  },
  upgradeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#6750A4',
  },
});
